import gql from "graphql-tag";

// TODO should actually fetch way less data here
// and fetch more data upon opening the PO view
// Same goes for the my/pos view
export const List = gql`
  query listMyPurchaseOrders {
    listMyPurchaseOrders {
      items {
        purchaseOrderId
        given_name
        family_name
        company_name
        company_code
        address_1
        address_2
        city
        state
        zip
        country
        email
        phone
        coupons
        teams
        createdAt
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/user/containers/PurchaseOrders/graphql.js